import { createPinia } from 'pinia'
import { createApp } from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import router from './router'
import { useAuthStore } from './stores/auth'
import { useUIStore } from './stores/ui'
import { installPublicTrafficTracking } from './composables/usePublicTrafficTracking'

loadFonts()

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)
app.use(vuetify)

// Initialize stores
const authStore = useAuthStore()
const uiStore = useUIStore()

authStore.initializeAuth()
uiStore.initializeUI()
installPublicTrafficTracking(router)

app.mount('#app')
